import { render } from "./invoices-main.vue?vue&type=template&id=3dcf0078"
import script from "./invoices-main.vue?vue&type=script&lang=js"
export * from "./invoices-main.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__